module.exports = "/images/estacion_metro.svg?a1f8e59e57c4c9638461d1f68afb66ee";